export default {
  'pages.friend.title': '好友与轻社交',
  'pages.friend.desc': '管理好友、设备入口与轻消息会话',
  'pages.friend.tabFriends': '好友列表',
  'pages.friend.tabRequests': '好友申请',
  'pages.friend.tabMyDevices': '我的设备',
  'pages.friend.viewDeviceMessages': '查看消息',
  'pages.friend.noMyDevices': '暂无绑定设备，绑定设备后可接收好友发来的设备消息',
  'pages.friend.myDeviceInbox': '我的设备消息',
  'pages.friend.noMyDeviceMessages': '还没有好友给这台设备发消息',
  'pages.friend.myDeviceInboxHint': '此处展示好友发给「我的设备」的消息（设备留言板）',
  'pages.friend.fromFriend': '来自好友',
  'pages.friend.addFriend': '添加好友',
  'pages.friend.search': '搜索',
  'pages.friend.reSearch': '重新搜索',
  'pages.friend.sendRequest': '发送申请',
  'pages.friend.kbaoNumber': '设备号',
  'pages.friend.kbaoTip': '设备号从 100000 起自动分配，随设备量自然增长',
  'pages.friend.phone': '手机号',
  'pages.friend.phonePlaceholder': '对方注册手机号',
  'pages.friend.mac': '设备 MAC',
  'pages.friend.requestMessage': '申请留言',
  'pages.friend.messagePlaceholder': '我是…，想和你的设备做朋友',
  'pages.friend.alreadyFriend': '已经是好友啦',
  'pages.friend.searchFail': '未找到匹配用户',
  'pages.friend.requestSent': '申请已发送，等待对方确认',
  'pages.friend.accepted': '已添加为好友',
  'pages.friend.rejected': '已拒绝',
  'pages.friend.accept': '接受',
  'pages.friend.reject': '拒绝',
  'pages.friend.chat': '消息',
  'pages.friend.devices': '设备',
  'pages.friend.edit': '编辑',
  'pages.friend.block': '拉黑',
  'pages.friend.unblock': '恢复',
  'pages.friend.delete': '删除',
  'pages.friend.updated': '已更新',
  'pages.friend.blocked': '已拉黑',
  'pages.friend.unblocked': '已取消拉黑',
  'pages.friend.deleted': '已删除好友',
  'pages.friend.deviceDeleted': '已删除设备入口',
  'pages.friend.opFail': '操作失败',
  'pages.friend.sendFail': '发送失败',
  'pages.friend.confirmBlock': '拉黑后对方无法与你通信，确定？',
  'pages.friend.confirmUnblock': '取消拉黑该好友？',
  'pages.friend.confirmDelete': '删除好友将同时清除你的设备入口，会话记录保留，确定？',
  'pages.friend.confirmDeviceBlock': '屏蔽该设备入口？仅影响此设备',
  'pages.friend.confirmDeviceUnblock': '恢复该设备入口？',
  'pages.friend.confirmDeviceDelete': '删除该设备入口？',
  'pages.friend.colFriend': '好友',
  'pages.friend.colUsername': '用户名',
  'pages.friend.colTags': '标签',
  'pages.friend.colStatus': '状态',
  'pages.friend.colUnread': '未读',
  'pages.friend.colLastMessage': '最近消息',
  'pages.friend.colAddedAt': '添加时间',
  'pages.friend.colActions': '操作',
  'pages.friend.colPeer': '对方',
  'pages.friend.colTargetType': '申请类型',
  'pages.friend.colMessage': '申请留言',
  'pages.friend.colCreatedAt': '申请时间',
  'pages.friend.colDevice': '设备',
  'pages.friend.remark': '备注名',
  'pages.friend.remarkPlaceholder': '给好友起个名字',
  'pages.friend.tags': '标签',
  'pages.friend.tagsPlaceholder': '输入后回车添加，如：同学、家人',
  'pages.friend.editFriend': '编辑好友',
  'pages.friend.editDevice': '编辑设备入口',
  'pages.friend.deviceRemarkPlaceholder': '如：小明家的设备',
  'pages.friend.devicesOf': '设备入口',
  'pages.friend.noDevices': '暂无共享的设备',
  'pages.friend.boundAgent': '绑定智能体',
  'pages.friend.chatWith': '与',
  'pages.friend.chatSuffix': '的会话',
  'pages.friend.noMessages': '还没有消息，发一条打个招呼吧',
  'pages.friend.inputPlaceholder': '输入消息…',
  'pages.friend.send': '发送',
  'pages.friend.loading': '加载中…',
  'pages.friend.searchPlaceholder': '按备注 / 昵称 / 用户名搜索',
  'pages.friend.outboxTitle': '我发出的申请',
  'pages.friend.noOutbox': '暂无发出的申请',
  'pages.friend.cancel': '取消',
  'pages.friend.status.blocked': '已拉黑',
  'pages.friend.status.pending': '待确认',
  'pages.friend.status.accepted': '正常',
  'pages.friend.status.rejected': '已拒绝',
  'pages.friend.target.device': '设备',
  'pages.friend.target.user': '用户',
  'pages.friend.msg.read': '已读',
  'pages.friend.msg.delivered': '已送达',
  'pages.friend.msg.failed': '发送失败',
  'pages.friend.msg.sent': '已发送',
  'pages.friend.sendImage': '发送图片',
  'pages.friend.imagePresetOnly': '图片仅支持上方预置图片，不支持自定义上传',
  'pages.friend.copied': '已复制',
  'pages.friend.tplTabText': '常用语',
  'pages.friend.tplTabEmoji': '表情',
  'pages.friend.tplTabImage': '图片',
  'pages.friend.sendEmoji': '发送表情',
  'pages.friend.sendPresetImage': '发送预置图片',
  'pages.friend.loadEarlier': '加载更早的消息',
  'pages.friend.noMoreMessages': '没有更早的消息了',
  'pages.friend.tabChats': '会话',
  'pages.friend.conversationList': '会话列表',
  'pages.friend.friendsGroup': '好友',
  'pages.friend.myDevicesGroup': '我的设备收件箱',
  'pages.friend.noChatSelected': '选择左侧好友或设备，开始聊天',
  'pages.friend.sendAs': '发送身份',
  'pages.friend.asUser': '以用户身份发送',
  'pages.friend.asDevice': '以设备身份发送',
  'pages.friend.noDeviceSender': '暂无绑定设备，绑定后可选以设备名义发送',
  'pages.friend.tagUser': '用户',
  'pages.friend.tagDevice': '设备',
  'pages.friend.sendTo': '发给',
  'pages.friend.toUser': '用户',
  'pages.friend.toDevice': '设备',
  'pages.friend.tabCalls': 'AI 通话记录',
  'pages.call.title': 'AI 通话记录',
  'pages.call.desc': '查看与好友智能体 AI 通话的列表与详情；设备可说：和小雨 AI 通话，聊作业，一分钟',
  'pages.call.listTitle': 'AI 通话记录',
  'pages.call.detailTitle': '通话详情',
  'pages.call.colCaller': '呼叫方',
  'pages.call.colCallee': '呼入方',
  'pages.call.colDirection': '方向',
  'pages.call.colTopic': '主题',
  'pages.call.colRequired': '要求时长',
  'pages.call.colActual': '实际时长',
  'pages.call.colTurns': '轮数',
  'pages.call.colState': '状态',
  'pages.call.colHangup': '挂断原因',
  'pages.call.colCreatedAt': '时间',
  'pages.call.colActions': '操作',
  'pages.call.colTitle': '标题',
  'pages.call.colSummary': '摘要',
  'pages.call.viewDetail': '详情',
  'pages.call.turnsTitle': '通话台词',
  'pages.call.noTurns': '暂无台词记录',
  'pages.call.loading': '加载中…',
};
